module.exports = __webpack_public_path__ + "img/Tech - Maxwell Wagoner-Watts-1.d47135e2.png";